export type SavedCompetitorAdReference = {
  clientId: string; src: string; brandId: number; competitorId: number; savedAdId: number;
  source: 'saved_competitor_ad';
};
export type SavedCompetitorAdReceipt = {
  version: 1; source: 'saved_competitor_ad'; userId: number; brandId: number; projectId: number;
  sourceMessageId: string; competitorId: number; selectedIds: number[];
};
export function isSavedCompetitorAdCanvasId(id: unknown): id is string {
  return typeof id === 'string' && /^saved-competitor-ad-\d+-\d+-\d+-[a-f0-9]{12}$/.test(id);
}
export function validSavedCompetitorAdReceipt(value: any, scope: {userId:number;brandId:number;projectId:number}, rowId: string): value is SavedCompetitorAdReceipt {
  return value?.version === 1 && value.source === 'saved_competitor_ad' && value.userId === scope.userId && value.brandId === scope.brandId && value.projectId === scope.projectId && value.sourceMessageId === rowId && Number.isSafeInteger(value.competitorId) && value.competitorId > 0 && Array.isArray(value.selectedIds) && value.selectedIds.length <= 1000 && new Set(value.selectedIds).size === value.selectedIds.length && value.selectedIds.every((id:any) => Number.isSafeInteger(id) && id > 0);
}

/** A cheap read boundary, not the interpreter. Positive writes/generation remain on their own routes. */
export function savedCompetitorReadCandidate(message:string):boolean {
  const text=message.replace(/[’‘]/g,"'").replace(/\b(?:do not|don't|never)\s+(?:generate|create|make|render|scan|rescan|change|edit)\b/gi,'');
  if(/\b(?:generate|create|make|render|remake|clone|adapt|scan|rescan|rename|delete|remove|update|change|edit|save)\b/i.test(text))return false;
  if(/\b(?:link|collections?)\b/i.test(text)&&! /\b(?:canvas|chat|previews?)\b/i.test(text))return false;
  return /\b(?:show|display|browse|view|put|place|bring|add)\b/i.test(text)&&/\b(?:ads|originals|them)\b/i.test(text)&&/\b(?:saved|stored|existing|competitors?|their|them|those|these)\b/i.test(text);
}

